<template>
  <div v-loading="loading">
    <div class="title">项目详情</div>
    <div class="project-container">
      <div
        class="tree-container"
        :style="{ width: treeWidth, paddingRight: treePaddingRight }"
      >
        <el-button
          type="primary"
          size="small"
          plain
          style="width: 100%"
          class="mb-12"
          :disabled="isDisabled"
          @click="handleAddProjectPage"
          >添加项目页面</el-button
        >
        <el-tree
          :data="treeDatas"
          :props="treeProps"
          node-key="tId"
          :indent="0"
          :highlight-current="true"
          default-expand-all
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          :draggable="true"
          :allow-drop="allowDrop"
          :allow-drag="allowDrag"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span class="tree-label">{{ data.name }}</span>
            <span v-if="!isDisabled">
              <el-link
                class="tree-operation"
                v-if="!data.pages"
                icon="el-icon-remove-outline"
                type="danger"
                :underline="false"
                @click="() => handleRemoveProjectPage(node, data)"
              ></el-link>
            </span>
          </span>
        </el-tree>
      </div>
      <div class="content-container" :style="{ borderLeft: contentBorderLeft }">
        <div
          v-if="projectInfo.status > 2"
          class="fold-icon-wrapper"
          :class="{ fold: collapse }"
          @click="handleCollapse"
        >
          <zhu-svg svg-class="fold-icon" svg-name="fold"></zhu-svg>
        </div>
        <div class="content-title">
          <div v-show="pageMode === 'base'">
            <el-divider>基本设置</el-divider>
          </div>
          <div v-show="pageMode === 'detail'">
            <el-divider>项目内容详情</el-divider>
          </div>
        </div>
        <div class="content-info">
          <div class="basic-info" v-show="pageMode === 'base'">
            <div class="basic-info-item">
              <el-form
                label-width="110px"
                ref="projectInfo"
                :model="projectInfo"
                :rules="projectRules"
              >
                <el-form-item label="项目状态：">
                  {{ projectInfo.status_label }}
                </el-form-item>
                <el-form-item label="项目名称：">
                  <el-input
                    class="w-400"
                    v-model="projectInfo.name"
                    size="small"
                    :disabled="isDisabled"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="项目类型："
                  prop="type"
                  :show-message="false"
                >
                  <el-select
                    class="w-400"
                    size="small"
                    v-model="projectInfo.type"
                    placeholder="请选择项目类型"
                    :disabled="isDisabled"
                  >
                    <el-option :value="1" label="工程型"></el-option>
                    <el-option :value="2" label="技能型"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="项目难度：" prop="project_difficult_level">
                  <el-select
                    size="small"
                    class="w-400"
                    v-model="projectInfo.project_difficult_level"
                    placeholder="请选择项目难度"
                    :disabled="isDisabled"
                  >
                    <el-option
                      v-for="(item, index) in difficultyList"
                      :key="index + 1"
                      :label="item"
                      :value="index + 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="岗位级别："
                  prop="difficult_level_id"
                  :show-message="false"
                >
                  <el-select
                    class="w-400"
                    size="small"
                    v-model="projectInfo.difficult_level_id"
                    placeholder="请选择岗位级别"
                    :disabled="isDisabled"
                  >
                    <el-option-group
                      v-for="group in skillModelOptions"
                      :key="group.id"
                      :label="group.name"
                    >
                      <el-option
                        v-for="item in group.children"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="学习场景："
                  prop="scene"
                  :show-message="false"
                >
                  <el-input
                    class="w-400"
                    v-model="projectInfo.scene"
                    size="small"
                    type="textarea"
                    placeholder="请输入项目场景："
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    :disabled="isDisabled"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="项目目标："
                  prop="study_aim"
                  :show-message="false"
                >
                  <el-input
                    class="w-400"
                    v-model="projectInfo.study_aim"
                    size="small"
                    type="textarea"
                    placeholder="请输入项目场景："
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    :disabled="isDisabled"
                  ></el-input>
                </el-form-item>

                <el-form-item label="行业分类：">
                  <el-cascader
                    v-model="projectInfo.common_industries"
                    :options="industryList"
                    :props="optionProps"
                    class="w-400"
                    placeholder="请选择行业分类"
                    :disabled="isDisabled"
                  ></el-cascader>
                </el-form-item>

                <el-form-item
                  label="前置技能："
                  prop="type"
                  :show-message="false"
                >
                  <ProjectStackSelect
                    :stacks="projectInfo.pre_skills"
                    :disabled="isDisabled"
                  ></ProjectStackSelect>
                </el-form-item>

                <el-form-item
                  label="提升目标："
                  prop="type"
                  :show-message="false"
                >
                  <ProjectStackSelect
                    :stacks="projectInfo.aim_skills"
                    :disabled="isDisabled"
                  ></ProjectStackSelect>
                </el-form-item>

                <el-divider>项目拆解</el-divider>

                <DraggableTask
                  :disabled="isDisabled"
                  :datas.sync="projectInfo.pages"
                ></DraggableTask>
              </el-form>
            </div>
          </div>
          <div class="detail-info" v-show="pageMode === 'detail'">
            <el-form label-width="200px">
              <el-form-item label="任务名称：">
                <el-input
                  class="w-400"
                  v-model="pageDetail.name"
                  size="small"
                  clearable
                  :disabled="isDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item label="任务描述：">
                <el-input
                  class="w-400"
                  v-model="pageDetail.description"
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  :disabled="isDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item label="任务时长：">
                <el-input
                  class="w-150"
                  v-model.number="pageDetail.duration"
                  size="small"
                  :disabled="isDisabled"
                >
                  <template slot="append">小时</template>
                </el-input>
              </el-form-item>
            </el-form>
            <el-divider></el-divider>
            <PageTemplate
              :pageTemplate="pageDetail.contents"
              defaultOpen="edit"
              :disabled="isDisabled"
            ></PageTemplate>
          </div>
          <div
            style="text-align: right;"
            class="mt-12"
            v-if="
              !loading &&
                authPermissions.includes(
                  'project.api.fuwu_admin.projects.update'
                )
            "
          >
            <el-button
              v-if="projectInfo.status == 1"
              size="small"
              class="ml-12"
              @click="upDateProjectInfo(2)"
              >提交审核</el-button
            >
            <el-popconfirm
              v-if="projectInfo.status == 3"
              class="mr-12"
              title="提交封测, 是否继续？"
              @onConfirm="closeTestConfirm"
            >
              <el-button size="small" class="ml-12" slot="reference"
                >提交封测</el-button
              >
            </el-popconfirm>
            <el-button
              v-if="!editDisable"
              size="small"
              :type="editing ? 'danger' : 'primary'"
              :loading="saveLoading"
              @click="toggleEdit"
              >{{ editing ? "保存项目" : "编辑信息" }}</el-button
            >

            <el-button
              size="small"
              class="ml-12"
              v-if="false"
              @click="handleCancelEdit"
              type="primary"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import API from "@/global/request/api";
import PageTemplate from "@/components/PageTemplate";
import ProjectStackSelect from "@/components/ProjectStackSelect";
import projectService from "@/global/service/project";
import kcellService from "@/global/service/kcell";
import DraggableTask from "./widgets/DraggableTask.vue";

export default {
  components: {
    PageTemplate,
    DraggableTask,
    ProjectStackSelect
  },
  data() {
    return {
      pageMode: "base",
      difficultyList: [
        "R1-简单",
        "R2-一般",
        "R3-中等",
        "R4-困难",
        "R5-非常困难"
      ],
      loading: true,
      btnLoading: false,
      saveLoading: false,
      editing: false,
      isDisabled: true,
      collapse: false,
      api: API.projectFile,
      pageDetail: {},
      taskInfo: {
        task_id: null,
        job_id: null,
        unit_price_min: null,
        unit_price_max: null
      },
      projectInfo: {
        name: "默认模板",
        status: null,
        teacher_production_price: null,
        company_consume_price: null,
        teacher_evaluate_price: null,
        company_evaluate_price: null,
        cover_file: {
          id: null,
          path: ""
        },
        common_industries: [],
        type: null,
        duration: null,
        difficult_level_id: null,
        scene: null,
        study_aim: null,
        pages: [],
        pre_skills: [],
        aim_skills: [],
        project_difficult_level: ""
      },
      projectRules: {
        name: { required: true, trigger: "blur" },
        type: { required: true, trigger: "blur" },
        duration: { required: true, trigger: "blur" },
        difficult_level_id: { required: true, trigger: "blur" },
        scene: { required: true, trigger: "blur" },
        study_aim: { required: true, trigger: "blur" },
        teacher_production_price: { trigger: "blur", type: "number" },
        company_consume_price: { trigger: "blur", type: "number" },
        teacher_evaluate_price: { trigger: "blur", type: "number" },
        company_evaluate_price: { trigger: "blur", type: "number" },
        project_difficult_level: { required: true, trigger: "blur" }
      },
      treeProps: {
        label: "name",
        children: "pages"
      },
      projectVisible: false,
      pageTemplateValue: null,
      treeFixed: false,
      skillModelOptions: [],
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"]),
    treeWidth() {
      return this.collapse ? 0 : "200px";
    },
    treePaddingRight() {
      return this.collapse ? 0 : "30px";
    },
    contentBorderLeft() {
      return this.collapse ? "none" : "1px solid #e9eaf2";
    },
    treeDatas() {
      const name = this.projectInfo.name;
      const pages = this.projectInfo.pages;
      return [{ name, pages }];
    },
    projectDuration() {
      return this.projectInfo.pages.reduce(
        (pre, cur) => pre + Number(cur.duration),
        0
      );
    },
    editDisable() {
      return [2, 6, 7].includes(this.projectInfo.status);
    }
  },
  created() {
    this.getData();
    this.getConst();
  },
  methods: {
    getConst() {
      kcellService.kcellIndustry().then(res => {
        this.industryList = res;
      });
    },
    getData() {
      const id = this.$route.params.id;
      projectService
        .item(id)
        .then(res => {
          res.difficult_level_id = res.difficult_level.id;
          this.projectInfo = res;
          this.projectInfo.job_id = res.job.id;
          this.projectInfo.common_industries = res.common_industries.map(
            item => item.id
          );
          this.collapse = this.projectInfo.status <= 2;
          this.getPositionSkillModel(res.job.id);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPositionSkillModel(id) {
      kcellService.kcellPositionsSkillModel(id).then(res => {
        this.skillModelOptions = res.levels;
      });
    },
    handleNodeClick(data) {
      if (this.isDelete) {
        this.isDelete = false;
        return;
      }
      this.pageDetail = data;
      this.pageMode = data.pages ? "base" : "detail";
    },
    handleCollapse() {
      this.collapse = !this.collapse;
    },
    handleAddProjectPage() {
      let tId = Date.now();
      this.projectInfo.pages.push({
        tId,
        name: "单页模版",
        description: "",
        duration: 0,
        contents: []
      });
    },
    removeProjectPageInTable(data) {
      const index = this.projectInfo.pages.indexOf(data);
      this.projectInfo.pages.splice(index, 1);
    },
    handleRemoveProjectPage(node, data) {
      if (this.pageDetail.id === data.id) {
        this.$notify({
          title: "警告",
          message: "不能直接删除正在展示的模版，请切换后再进行删除！",
          type: "warning"
        });
        return;
      }

      this.isDelete = true;
      this.removeProjectPageInTable(data);
    },
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.level !== dropNode.level) {
        return false;
      } else {
        if (draggingNode.parent.id === dropNode.parent.id) {
          return type === "prev" || type === "next";
        }
      }
    },
    allowDrag(draggingNode) {
      if (!draggingNode.isLeaf) {
        return false;
      } else {
        return true;
      }
    },
    toggleEdit() {
      if (this.editing === false) {
        this.isDisabled = false;
        this.editing = true;
      } else {
        this.upDateProjectInfo(false);
      }
    },
    handleCancelEdit() {
      this.editing = false;
      this.isDisabled = true;
      this.getData();
    },
    closeTestConfirm() {
      this.upDateProjectInfo(4);
    },
    upDateProjectInfo(status) {
      const id = this.$route.params.id;
      this.$refs["projectInfo"].validate(val => {
        if (!val) {
          this.$message.error("项目基本设置缺少必要参数");
          return;
        }
        const params = Object.assign({}, this.projectInfo);
        params.cover_file_id = params.cover_file ? params.cover_file.id : null;
        params.duration = this.projectDuration;
        if (status) {
          params.status = status;
        } else {
          delete params.status;
        }

        const hasPreSkills = params.pre_skills.length;
        const hasAimSkills = params.aim_skills.length;
        if (!hasPreSkills) return this.$message.error("前置技能不能为空 ～");
        if (!hasAimSkills) return this.$message.error("目标技能不能为空 ～");
        const hasSelectPreSkillLevel = params.pre_skills.every(
          d => d.level || d.level === 0
        );
        const hasSelectAimSkillLevel = params.aim_skills.every(
          d => d.level || d.level === 0
        );
        if (!hasSelectPreSkillLevel)
          return this.$message.error("前置的技能水平不能为空 ～");
        if (!hasSelectAimSkillLevel)
          return this.$message.error("目标的技能水平不能为空 ～");

        const isFullMessage = params.pages.every(data => {
          return data.name && data.description && data.duration;
        });

        if (!isFullMessage) return this.$message.error("项目拆解信息不全 ～");
        if (!params.pages.length)
          return this.$message.error("项目至少应拥有一个模版页面 ～");

        this.btnLoading = true;
        projectService
          .update(id, params)
          .then(() => {
            let message = "保存成功";
            if (status === 2) message = "已提交审核";
            if (status === 4) message = "已提交封测";
            this.$message.success(message);
            if (status) this.projectInfo.status += 1;
            this.isDisabled = true;
            this.editing = false;
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  margin-bottom: 12px;
}
.project-container {
  display: flex;
  .tree-container {
    padding-top: 12px;
    min-height: 500px;
    transition: all 0.2s ease-out;
    overflow: hidden;
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 8px;
      font-size: 14px;
      .tree-label {
        width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .tree-operation {
        height: 0;
        overflow: hidden;
      }
      &:hover .tree-operation {
        height: 14px;
      }
    }
  }
  .content-container {
    position: relative;
    flex: 1;
    padding-left: 30px;
    min-width: 740px;
    .fold-icon-wrapper {
      position: absolute;
      top: 22px;
      left: -20px;
      z-index: 1;
      width: 20px;
      height: 32px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #dee0e3;
      border-radius: 4px;
      background-color: #fff;
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      transition: all 0.2s ease-out;
      cursor: pointer;
      &.fold {
        left: -30px;
        transform: rotate(180deg);
      }
      .fold-icon {
        color: #656a72;
        &:hover {
          color: #409eff;
        }
      }
    }
    .content-info {
      .basic-info {
        margin-top: 48px;
        text-align: center;
        .basic-info- {
          display: inline-block;
          width: 510px;
        }
        .project-img {
          display: inline-block;
          width: 100%;
          text-align: left;
          img {
            width: 140px;
            height: 140px;
          }
        }
        .project-img-none {
          display: inline-block;
          margin-left: 4px;
          width: 100%;
          text-align: left;
        }
      }
      .detail-info {
        margin-top: 36px;
        .detail-info-item {
          position: relative;
          margin-bottom: 24px;
          .md {
            text-align: left;
          }
          .clock-in {
            padding: 16px 0;
            width: 100%;
            text-align: center;
            .clock-in-title {
              display: inline-block;
              margin-bottom: 16px;
              width: 70%;
            }
            .clock-in-description {
              margin-bottom: 24px;
              font-size: 12px;
            }
          }
          .qa {
            padding: 16px 0;
            width: 100%;
            text-align: center;
            .qa-refresh {
              position: absolute;
              top: 16px;
              right: 16px;
              font-size: 16px;
            }
            .qa-name {
              display: inline-block;
              margin-bottom: 16px;
              width: 70%;
              .qa-img {
                margin-right: 8px;
                width: 30px;
                height: 30px;
                vertical-align: middle;
              }
              span {
                vertical-align: middle;
              }
            }
            .qa-description {
              margin-bottom: 24px;
              font-size: 12px;
            }
            .qa-btn {
              margin: 0 8px;
            }
          }
          .review {
            padding: 16px 0;
            width: 100%;
            text-align: center;
            .review-refresh {
              position: absolute;
              top: 16px;
              right: 16px;
              font-size: 16px;
            }
            .review-name {
              display: inline-block;
              margin-bottom: 16px;
              width: 70%;
            }
            .review-description {
              margin-bottom: 32px;
              font-size: 12px;
            }
            .review-content-list {
              display: flex;
              justify-content: center;
              .review-content-item {
                margin: 0 12px;
                cursor: pointer;
                &:hover {
                  opacity: 0.8;
                }
                img {
                  display: block;
                  margin: 0 auto 10px;
                  width: 36px;
                  height: 36px;
                }
                span {
                  display: inline-block;
                  max-width: 90px;
                  font-size: 14px;
                  vertical-align: middle;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }
            .review-select-list {
              display: inline-block;
              padding-left: 5%;
              width: 40%;
              text-align: left;
              .review-select-item {
                margin-bottom: 8px;
                width: 100%;
              }
            }
            .review-btn {
              margin-top: 12px;
            }
            .review-result {
              margin-top: 12px;
              img {
                margin-right: 12px;
                width: 36px;
                height: 36px;
                vertical-align: middle;
              }
              span {
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
  }
}
/deep/.el-input-group__append {
  border: none;
}
</style>
